import AssetSearch from "../../mixins/asset-search";

Vue.component("inspection-asset-select-form", {

  mixins: [AssetSearch],

  props: ["inspection"],

  data() {
    return {
      assetSelectForm: new AppForm({}),
      selectedAsset: null
    };
  },

  mounted() {

    Bus.$on("show-asset-select-form", function() {
      $("#modal-inspection-asset-select-form").modal("show");
    });

  },

  methods: {

    updateInspectionAsset() {
      this.assetSelectForm.selected_asset_id = this.selectedAsset?.id;
      App.patch("/inspections/" + this.inspection.id + "/asset/change", this.assetSelectForm)
        .then(response => {
          toastr.success(App.lang.assetName + " updated!");
          Bus.$emit("inspection-updated", response);
          $("#modal-inspection-asset-select-form").modal("hide");
        })
        .catch(errors => {
          toastr.error("Could not update " + App.lang.asset.name + "!");
        });
    }

  }

});